import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Icon from "@/components/icon/Icon";
import { ArrowRight1_5px, CouponFilled, Sizes } from "@/components/icon/IconList";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { Button } from "@bookips/solvook-ui-library";
import { Box, Typography, useTheme } from "@mui/material";
const CouponAlert = (param)=>{
    let { onClick  } = param;
    const theme = useTheme();
    return /*#__PURE__*/ _jsxs(Button, {
        disableRipple: true,
        onClick: ()=>{
            onClick();
            //mx-39 공통으로 쓴다면 한곳에서 이벤트 관리
            mixpanelEvent("Coupon Get Button Clicked", {
                "Button Name": "적용 가능한 쿠폰 받기"
            });
        },
        sx: {
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            backgroundColor: theme.palette.red[0],
            marginTop: "8px",
            ":hover": {
                backgroundColor: theme.palette.red[100]
            }
        },
        children: [
            /*#__PURE__*/ _jsxs(Box, {
                sx: {
                    display: "flex",
                    gap: 1,
                    alignItems: "center"
                },
                children: [
                    /*#__PURE__*/ _jsx(Icon, {
                        icon: CouponFilled,
                        size: Sizes.small,
                        color: theme.palette.red[400]
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "subtitle2",
                        sx: {
                            color: "red.400"
                        },
                        children: "적용 가능한 쿠폰 받기"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Icon, {
                icon: ArrowRight1_5px,
                size: Sizes.smallHalf,
                color: theme.palette.status.error
            })
        ]
    });
};
export default CouponAlert;
